import { FC, useEffect, useState } from 'react';
import { pageKey } from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { DatePicker } from '../../../date-time/date-picker/date-picker';
import { PresetType, TableDatePresets } from '../table-date-presets/table-date-presets';
import { TableFilter } from '../table-filter';
import s from './table-filter-date-range.module.css';

interface Props {
  name: string;
}

export const TableFilterDateRange: FC<Props> = (props) => {
  const { name } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  const { t } = useLang();
  const [preset, setPreset] = useState<PresetType | undefined>();

  useEffect(() => {
    const range = getQueryParams()[name];

    if (!range) {
      return;
    }
    const asObj = JSON.parse(range);
    const from = asObj.from ? new Date(asObj.from) : undefined;
    const to = asObj.to ? new Date(asObj.to) : undefined;
    setFrom(from);
    setTo(to);
  }, [name]);

  const handleOk = () => {
    if (from || to) {
      addQueryParams({ [name]: JSON.stringify({ from, to }), [pageKey]: '1' });
    }
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setFrom(undefined);
    setTo(undefined);
    setPreset(undefined);
  };

  const handlePresetClick = (preset: PresetType) => {
    setPreset(preset);
    setFrom(preset?.range[0].toDate());
    setTo(preset?.range[1].toDate());
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      <div className={s.feature}>
        <DatePicker selectedDate={from} onSelectDate={setFrom} placeholder={t('От')} />
        <DatePicker selectedDate={to} onSelectDate={setTo} placeholder={t('До')} />
      </div>

      <TableDatePresets activePresetKey={preset?.key} onClick={handlePresetClick} />
    </TableFilter>
  );
};
